export const MarketingTypeDecorator = {
  url() {
    return `signup-hubspot/marketing`;
  },

  query() {
    return {};
  }

};